module.exports = __webpack_public_path__ + "static/bg-edd1da5f3e1111a6921af25ed4fa3a94.png";